import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/useAuthStore';
import apiClient from '../api/client';

const Navbar = ({ activeTab, onChangeTab }) => {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);
  const user = useAuthStore((state) => state.user);
  const isAdmin = user?.role === 'admin' || user?.role === 'Admin';

  // Different tabs for admin vs regular users
  const tabs = isAdmin
    ? [
        { id: 'upload', label: 'Upload' },
        { id: 'manage', label: 'Manage' },
        { id: 'stats', label: 'Statistics' }
      ]
    : [
        { id: 'annotate', label: 'Annotate' },
        { id: 'stats', label: 'Statistics' }
      ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleExportCSV = async () => {
    try {
      const response = await apiClient.get(`/media/export-csv-hate?t=${Date.now()}`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `hate-annotations-${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to export CSV');
    }
  };

  const handleExportMemeCSV = async () => {
    try {
      const response = await apiClient.get(`/media/export-csv-meme?t=${Date.now()}`, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `meme-annotations-${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to export CSV');
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <span className="brand">MMHS Annotator</span>
        <div className="tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={tab.id === activeTab ? 'tab active' : 'tab'}
              onClick={() => onChangeTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      <div className="navbar-right">
        {user && <span className="user-name">{user.name}</span>}
        {user?.role === 'admin' && (
          <>
            <button type="button" className="secondary" onClick={handleExportCSV}>
              Export Hate CSV
            </button>
            <button type="button" className="secondary" onClick={handleExportMemeCSV}>
              Export Meme CSV
            </button>
          </>
        )}
        <button type="button" className="logout" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </nav>
  );
};

Navbar.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onChangeTab: PropTypes.func.isRequired
};

export default Navbar;
